import * as React from 'react';
import { CalendarAssetCallbacksProvider } from 'owa-timestream-asset-sdk-calendars';
import { observer } from 'mobx-react-lite';
import { CalendarSublimity } from 'owa-calendar-canvas';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getFullCalendarEvent } from 'owa-calendar-forms-common/lib/helpers/eventStore';
import { getCalendarEventWithId } from 'owa-calendar-events-store';
import { lazyShowFullComposeInEditMode } from 'owa-calendar-compose-form-store';
import { FULL_COMPOSE_VIEW_TYPE_MODAL } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { lazyShowReadingPane } from 'owa-calendar-reading-pane-actions';
import EventScope from 'owa-service/lib/contract/EventScope';
import { getUserMailboxInfo } from 'owa-client-ids';
import { SkipLinkRegion } from 'owa-skip-link/lib/components/SkipLinkRegion';
import { jumpToRegion } from 'owa-locstrings/lib/strings/jumptoregion.locstring.json';
import { sublimityRegionName } from './CalendarModule.locstring.json';
import loc, { format } from 'owa-localize';

import * as styles from './CalendarModule.scss';

export default observer(function CalendarModuleCanvas() {
    const callbacks = {
        onOpenCalendarItem,
        onOpenCalendarItemDraft,
        onReviewProposedNewTime,
    };

    return (
        <SkipLinkRegion
            skipLinkName={format(loc(jumpToRegion), loc(sublimityRegionName))} // TODO VSO 95593: Finalize user-friendly term for Calendar Canvas feature
            className={styles.moduleSublimity}
            role="main"
            regionName={loc(sublimityRegionName)}>
            <CalendarAssetCallbacksProvider value={callbacks}>
                <CalendarSublimity />
            </CalendarAssetCallbacksProvider>
        </SkipLinkRegion>
    );
});

const SpacesCalendarAssetEntrySource = 'SpacesCalendarAsset';

function onOpenCalendarItem(itemId: string, shouldScrollToInsights?: boolean) {
    lazyShowReadingPane.importAndExecute(
        { Id: itemId, mailboxInfo: getUserMailboxInfo() },
        SpacesCalendarAssetEntrySource,
        false /* getSeriesMaster */,
        false /* isDeeplink */,
        true /* showModal */,
        false /*isInPopoutWindow */,
        shouldScrollToInsights
    );
}

function onOpenCalendarItemDraft(itemId: string) {
    const event = getCalendarEventWithId(itemId);
    lazyShowFullComposeInEditMode.importAndExecute(
        event,
        event.IsRecurring ? EventScope.AllInstancesInSeries : EventScope.Default,
        false /* itemHasUpdates */,
        SpacesCalendarAssetEntrySource,
        FULL_COMPOSE_VIEW_TYPE_MODAL,
        null /* extractionSourceId */
    );
}

function onReviewProposedNewTime(itemId: string, newEvent?: Partial<CalendarEvent>) {
    const event = getFullCalendarEvent(null, itemId);
    lazyShowFullComposeInEditMode.importAndExecute(
        {
            ...event,
            ...newEvent,
        },
        EventScope.Default,
        true /* itemHasUpdates */,
        SpacesCalendarAssetEntrySource,
        FULL_COMPOSE_VIEW_TYPE_MODAL,
        null /* extractionSourceId */
    );
}
